import { mergeModules } from "../core"
import createOfferRequest from "./createOfferRequest"
import categories from "./categories"
import questions from "./questions"

export default mergeModules(createOfferRequest, categories, questions)
